'use strict';

/* eslint-disable no-param-reassign */

var _require = require('bson'),
    ObjectId = _require.ObjectId;

var _require2 = require('codev-traverse'),
    traverse = _require2.traverse;

var collect = function collect(schema) {
  return function (ctx) {
    return function (next) {
      return function (value, path) {
        var reference = schema.reference;


        if (reference && ObjectId.isValid(value)) {
          ctx.populateMap.idsMap[reference] = ctx.populateMap.idsMap[reference] || [];
          ctx.populateMap.idsMap[reference].push(value);
          ctx.populateMap.actions.push({ path: path, reference: reference });
        }

        return next(value) || value;
      };
    };
  };
};

module.exports = function collectIds(schema, data) {
  var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  ctx.populateMap = { idsMap: {}, actions: [] };

  var traverseSchema = Array.isArray(data) ? { contents: [schema] } : schema;

  traverse(traverseSchema)(collect)(ctx)(data);
  return ctx.populateMap;
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/populate/collectIds.js
// module id = 1848
// module chunks = 0